module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/207/assets/images/0416d3d1ed9748dfe37557895aa84a3e.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_move_remove.svg
// module id = T0He
// module chunks = 1